import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "var(--color-black)",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 2.5a7.5 7.5 0 1 0 0 15 .833.833 0 0 1 0 1.667A9.167 9.167 0 1 1 10 .833.833.833 0 0 1 10 2.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 2.5a7.5 7.5 0 1 1 0 15 .833.833 0 0 0 0 1.667A9.167 9.167 0 0 0 10 .833.833.833 0 1 0 10 2.5",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.896 8.255c0-.198.16-.359.359-.359h3.587c.198 0 .358.16.358.359v3.587c0 .198-.16.358-.358.358H8.255a.36.36 0 0 1-.359-.358zm2.152 5.545H8.255c-.99 0-1.955-.968-1.955-1.958V8.255c0-.99.964-1.955 1.955-1.955h3.587c.99 0 1.958.964 1.958 1.955v3.587c0 .99-.968 1.958-1.958 1.958z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }